module.exports = __webpack_public_path__ + "static/media/OfferBook_ios_5.7c422ec1.jpg";